export const worldMap = {
  reset: "reajuste",
  resetMapSelections: "Restablecer las selecciones de mapas",
  zoomIn: "Hacer zoom",
  zoomOut: "Alejar",
  indicatorPanel: {
    indicatorPanelTitle: "El estado de la salud digital en el mundo actual",
    noHealthIndicatorAvailable: "No hay indicadores de salud disponibles",
    noDigitalIndicatorAvailable:
      "No hay indicadores de salud mundial disponibles",
    viewCountries: "Ver Países",
    viewDetails: "Ver Detalles",
    context: {
      text: "Contexto",
      gniPerCapita:
        "INB per cápita, método atlas (dólares estadounidenses corrientes)",
      totalPopulation: "Población total",
      adultLiteracyRate:
        "Tasa de alfabetización de adultos, población mayor de 15 años, ambos sexos (%)",
      easeOfDoingBusinessIndex: "Índice de facilidad para hacer negocios",
    },
    health: {
      text: "Salud",
      lifeExpectancy: "Esperanza de vida al nacer (años)",
      healthExpenditure: "Gasto en salud (% del PIB)",
      causeOfDeath:
        "Causa de muerte por enfermedades no transmisibles (% del total)",
      mortalityRate:
        "Tasa de mortalidad de menores de 5 años (por cada 1,000 nacidos vivos)",
    },
    description:
      "El Monitor de salud digital mundial (GDHM en inglés) es un recurso interactivo basado en web que tiene como objetivo " +
      "rastrear, monitorear y evaluar el entorno propicio para la salud digital en todo el mundo.",
  },
  searchCountry: "Buscar país",
  note: "Hecho con Tierra Natural.",
  note1: "fronteras indias",
  note2: "por",
  note3: "Comunidad DataMeet India",
};
